document.addEventListener("DOMContentLoaded", function () {

    /*
    * Navigation
    */
    const navigation = document.querySelector('.navigation');
    let currentDate = new Date(navigation.getAttribute('data-date_displayed'));

    function formatDate(date) {
        let day = String(date.getDate()).padStart(2, '0');
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    function updateUrlWithDate(date) {
        const formattedDate = formatDate(date);
        window.location.href = `?date=${formattedDate}`;
    }

    document.querySelector('.nav-button.prev').addEventListener('click', () => {
        currentDate.setDate(currentDate.getDate() - 1);
        updateUrlWithDate(currentDate);
    });

    document.querySelector('.nav-button.next').addEventListener('click', () => {
        currentDate.setDate(currentDate.getDate() + 1);
        updateUrlWithDate(currentDate);
    });

    document.querySelector('.nav-button.today').addEventListener('click', () => {
        currentDate = new Date();
        updateUrlWithDate(currentDate);
    });


    /*
    * Limitation du nombre de lignes (partie droite)
    * - calcule après chargement des polices et à chaque resize
    * - s'appuie sur la hauteur réelle du wrapper (flex:1)
    */
    const rightWrapper = document.querySelector('.screen-right .table-wrapper');
    const programTable = rightWrapper ? rightWrapper.querySelector('table.program-table') : null;

    function limitProgramRows() {
        if (!rightWrapper || !programTable) return;
        const tbodyRows = Array.from(programTable.querySelectorAll('tbody tr'));
        const thead = programTable.querySelector('thead');
        // réinitialiser l'affichage
        tbodyRows.forEach(r => (r.style.display = ''));

        const available = rightWrapper.clientHeight - (thead ? thead.offsetHeight : 0);
        let used = 0;
        for (const row of tbodyRows) {
            const h = row.offsetHeight;
            if (used + h <= available) {
                used += h;
            } else {
                row.style.display = 'none';
            }
        }
    }

    // Exécuter après chargement des polices (évite les mesures incorrectes sur TV/zoom)
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(limitProgramRows);
    } else {
        window.addEventListener('load', limitProgramRows);
    }
    // Recalcul sur resize et changement de devicePixelRatio (TV/projo)
    window.addEventListener('resize', limitProgramRows);
    const ro = new ResizeObserver(limitProgramRows);
    if (rightWrapper) ro.observe(rightWrapper);
    // Premier passage après DOM ready au cas où
    setTimeout(limitProgramRows, 0);
});
